import React, { useState, useRef } from 'react';
import './index.css';

function App() {
  const [imageFile, setImageFile] = useState(null);
  const [previewURL, setPreviewURL] = useState(null);
  const [heatmapURL, setHeatmapURL] = useState(null);
  const [loading, setLoading] = useState(false);
  const [elapsedTime, setElapsedTime] = useState(0);
  const [jobId, setJobId] = useState(null);
  const intervalRef = useRef(null);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setImageFile(file);
    setPreviewURL(URL.createObjectURL(file));
    setHeatmapURL(null);
    setElapsedTime(0);
  };

  const handlePredict = async () => {
    if (!imageFile) return;
    setLoading(true);
    setElapsedTime(0);

    const formData = new FormData();
    formData.append('file', imageFile);

    const response = await fetch('https://api-sam-867723251744.europe-west1.run.app/predict', {
      method: 'POST',
      body: formData,
    });

    const data = await response.json();
    setJobId(data.job_id);

    intervalRef.current = setInterval(() => {
      setElapsedTime((prev) => prev + 1);
    }, 1000);

    let result = null;
    for (let i = 0; i < 240; i++) {
      const res = await fetch(`https://api-sam-867723251744.europe-west1.run.app/results/${data.job_id}`);
      const json = await res.json();
      if (json.heatmap_base64) {
        result = json;
        break;
      }
      await new Promise((resolve) => setTimeout(resolve, 5000));
    }

    clearInterval(intervalRef.current);
    intervalRef.current = null;
    setLoading(false);

    if (result) {
      setHeatmapURL(result.heatmap_base64);
    } else {
      alert("⏱️ Prediction took too long.");
    }
  };

  return (
    <>
      <div className="fixed top-0 left-0 w-full h-full bg-gradient-to-br from-blue-200 via-purple-100 to-pink-200 animate-background-blur z-[-1]" />

      <div className="min-h-screen p-8 flex flex-col items-center justify-center">
        <h1 className="text-3xl font-bold text-center mb-6">Attention AI</h1>

        <div className="w-full max-w-7xl flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex flex-col items-center w-full md:w-1/3">
            <h2 className="font-semibold mb-2 text-center">Original Image</h2>
            {previewURL && (
              <img
                src={previewURL}
                alt="Preview"
                className="w-full min-w-[600px] max-w-[600px] rounded shadow border transform -translate-x-8"
              />
            )}
          </div>

          <div className="flex flex-col items-center justify-center w-full md:w-1/3 space-y-4">
            <input
              type="file"
              accept="image/*"
              onChange={handleImageUpload}
              className="px-4 py-2 border border-gray-300 rounded shadow text-sm bg-white"
            />
            <button
              onClick={handlePredict}
              className="px-6 py-2 bg-blue-600 text-white text-sm font-semibold rounded hover:bg-blue-700 shadow"
              disabled={!imageFile || loading}
            >
              Generate Heatmap
            </button>
          </div>

          <div className="flex flex-col items-center w-full md:w-1/3">
            <h2 className="font-semibold text-center mb-4">Heatmap</h2>
            {heatmapURL && (
              <img
                src={heatmapURL}
                alt="Heatmap"
                className="w-[600px] min-w-[600px] max-w-[600px] rounded shadow border ml-[100px]"
              />
            )}
          </div>
        </div>

        {loading && (
          <div className="mt-6 text-center">
            <p className="text-red-500 animate-pulse text-lg font-semibold">
              Scanning for attention zones...
            </p>
            <p className="mt-2 text-sm text-gray-700">
              Processing time: {Math.floor(elapsedTime / 60)} min {elapsedTime % 60} sec
            </p>
          </div>
        )}
      </div>
    </>
  );
}

export default App;